<template>
  <GroupBase>
    <Loader v-if="loading"/>

    <div v-else-if="teams.length > 0">
      <!-- FIXME: We need to add a field to say if the requestor is a member -->
      <GroupElement
        v-for="team in teams"
        :key="team.id"
        :name="team.name"
        :id="team.id"
        :isMember="team.is_member"
        :privacySetting="team.privacy_setting"
        />
    </div>

    <p v-else class="text-muted fs-6 text-center">You're not a member of any groups yet!</p>
</GroupBase>
</template>

<script>
import Loader from './Loader.vue'
import GroupBase from './GroupBase'
import GroupElement from './GroupElement'

import store from '../store.js'

export default {
  name: 'MyGroups',
  components: {
    Loader,
    GroupBase,
    GroupElement,
  },
  data () {
    return {
      privacy: ['blank', 'public', 'closed', 'private'],
    }
  },
  mounted () {
    store.dispatch('fetchTeams')
  },
  computed: {
    teams () {
      return store.state.teams
    },
    loading () {
      return store.state.loadingTeamData
    },
  },
}

</script>



// WEBPACK FOOTER //
// MyGroups.vue?235d806b